module.exports = __webpack_public_path__ + "static/media/logodaniela.1c53f82c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logodaniela.svg
// module id = 94
// module chunks = 0